import { DateTime } from 'luxon';
import { getApiCompanyMenuMeals } from '../../../../services/api/form/open/company.api';
import {
  changeMinMaxModalStatus,
  mealExchangeAddMenuMeal,
  mealExchangeChangeActiveDay,
  mealExchangeCreateDayList,
  mealExchangeSelectMenuMeal,
  mealExchangeToggleMeal,
} from '../../../../redux/actions/orderFormActions';
import CerealsWithGlutenIcon from '../../../../assets/icons/alergens/cerealsWithGlutenIcon';
import CrustaceansIcon from '../../../../assets/icons/alergens/crustaceansIcon';
import MilkIcon from '../../../../assets/icons/alergens/milkIcon';
import EggsIcon from '../../../../assets/icons/alergens/eggsIcon';
import PeanutsIcon from '../../../../assets/icons/alergens/peanutsIcon';
import FishIcon from '../../../../assets/icons/alergens/fishIcon';
import SoyIcon from '../../../../assets/icons/alergens/soyIcon';
import TreeNutsIcon from '../../../../assets/icons/alergens/treeNutsIcon';
import CeleryIcon from '../../../../assets/icons/alergens/celeryIcon';
import LupineIcon from '../../../../assets/icons/alergens/lupineIcon';
import MolluscsIcon from '../../../../assets/icons/alergens/molluscsIcon';
import MustardSeedsIcon from '../../../../assets/icons/alergens/mustardSeedsIcon';
import SesameIcon from '../../../../assets/icons/alergens/sesameIcon';
import SulphurDioxideIcon from '../../../../assets/icons/alergens/sulphurDioxideIcon';
import {
  createCalendarCarousel,
  maxMenuSelectionDaysAhead,
} from './carouselCalendarHelpers';
import {
  getLengthSelectedMeals,
  getLengthSelectedMealsWithSideOrders,
} from '../../../../utils/index';
import { getSelectedOption } from '../../../../redux/selectors/orderFormSelector';
import { nanoid } from '@reduxjs/toolkit';

export const getMenuMeals =
  (
    companyName,
    activeDay,
    selectedCalories,
    selectedDietOptionId,
    selectedMeals,
    serverUrl,
    apiKey
  ) =>
  (dispatch, getState) => {
    const selectedDietOption = getSelectedOption(getState());

    const mealsIdsWithDietOptionCalories =
      selectedMeals && selectedMeals?.length
        ? selectedMeals?.map(
            item => `${selectedDietOptionId}_${selectedCalories}_${item.mealId}`
          )
        : [];

    getApiCompanyMenuMeals(
      companyName,
      activeDay,
      mealsIdsWithDietOptionCalories.join(),
      serverUrl,
      apiKey,
      selectedDietOption.dietOptionId
    )
      .then(res => {
        const { data, status } = res;

        if (status === 200) {
          dispatch(mealExchangeCreateDayList(data));
        }
      })
      .catch(e => {
        console.log(e, 'e');
      });
  };

export const addMenuMeal =
  (companyName, activeDay, items, serverUrl, apiKey) =>
  (dispatch, getState) => {
    const selectedDietOption = getSelectedOption(getState());

    const mealsIdsWithDietOptionCalories = `${items.dietOptionId}_${items.calories}_${items.mealId}`;
    getApiCompanyMenuMeals(
      companyName,
      activeDay,
      mealsIdsWithDietOptionCalories,
      serverUrl,
      apiKey,
      selectedDietOption.dietOptionId
    ).then(res => {
      const { data, status } = res;

      if (status === 200) {
        dispatch(
          mealExchangeAddMenuMeal({
            ...items,
            list: data,
            id: nanoid(),
            additionalMeal: true,
          })
        );
      }
    });
  };

export const findAllergen = allergen => {
  const allergens = {
    CEREALS_WITH_GLUTEN: {
      allergenIcon: <CerealsWithGlutenIcon />,
      allergenName:
        'Zboża zawierające gluten, tj. pszenica, żyto, jęczmień, owies',
    },
    CRUSTACEANS: {
      allergenIcon: <CrustaceansIcon />,
      allergenName: 'Skorupiaki',
    },
    MILK: {
      allergenIcon: <MilkIcon />,
      allergenName: 'Mleko',
    },
    EGGS: {
      allergenIcon: <EggsIcon />,
      allergenName: 'Jaja',
    },
    PEANUTS: {
      allergenIcon: <PeanutsIcon />,
      allergenName: 'Orzeszki ziemne (arachidowe)',
    },
    FISH: {
      allergenIcon: <FishIcon />,
      allergenName: 'Ryby',
    },
    SOYBEANS: {
      allergenIcon: <SoyIcon />,
      allergenName: 'Soja',
    },
    TREE_NUTS: {
      allergenIcon: <TreeNutsIcon />,
      allergenName: 'Orzechy',
    },
    CELERY: {
      allergenIcon: <CeleryIcon />,
      allergenName: 'Seler',
    },
    LUPIN: {
      allergenIcon: <LupineIcon />,
      allergenName: 'Lupin',
    },
    MOLLUSCS: {
      allergenIcon: <MolluscsIcon />,
      allergenName: 'Mięczaki',
    },
    MUSTARD_SEEDS: {
      allergenIcon: <MustardSeedsIcon />,
      allergenName: 'Gorczyca',
    },
    SESAME_SEEDS: {
      allergenIcon: <SesameIcon />,
      allergenName: 'Sezam',
    },
    SULPHUR_DIOXIDE: {
      allergenIcon: <SulphurDioxideIcon />,
      allergenName: 'Dwutlenek siarki',
    },
  };

  return allergens[allergen];
};

const capitalizeFirstLetter = s => (s && s[0].toUpperCase() + s.slice(1)) || '';

export const parseTitle = activeDay => {
  const dateTime = DateTime.fromISO(activeDay);
  return `${capitalizeFirstLetter(
    dateTime.weekdayLong
  )} (${dateTime.toLocaleString()})`;
};

export const getParsedFirstDay = selectedDays =>
  selectedDays.map(item => DateTime.fromMillis(item).toISODate()).sort()[0];

export const handleClickNextBackButton =
  (direction, activeDay, selectedDays) => dispatch => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    const fromIso = DateTime?.fromISO(activeDay);

    const minus = day =>
      fromIso?.minus({
        day,
      });

    const plus = day =>
      fromIso?.plus({
        day,
      });

    return createCalendarCarousel(selectedDays).find((item, index) => {
      if (
        selectedDays?.includes(
          (direction === 'next' ? plus(index + 1) : minus(index + 1)).toMillis()
        )
      ) {
        return dispatch(
          mealExchangeChangeActiveDay(
            (direction === 'next'
              ? plus(index + 1)
              : minus(index + 1)
            ).toISODate()
          )
        );
      }
      return null;
    });
  };

export const isNextBackButtonDisabled = (
  value,
  selectedDays,
  activeDay,
  formSettings
) => {
  const sortedSelectedDays = [...selectedDays].sort();
  const activeDayIndex = sortedSelectedDays.indexOf(
    DateTime.fromISO(activeDay).toMillis()
  );
  const nextDayIndex = activeDayIndex + 1;
  const nextDay = selectedDays[nextDayIndex];

  if (formSettings) {
    return (
      activeDayIndex === value ||
      maxMenuSelectionDaysAhead(
        formSettings,
        DateTime.fromMillis(nextDay).toISODate()
      )
    );
  }

  return activeDayIndex === value;
};

export const exchangeMeal =
  (companyName, activeDay, id, meal, mealId, serverUrl, apiKey) =>
  (dispatch, getState) => {
    const selectedDietOption = getSelectedOption(getState());

    const mealsIdsWithDietOptionCalories = `${meal.dietOptionId}_${meal.calories}_${mealId}`;
    getApiCompanyMenuMeals(
      companyName,
      activeDay,
      mealsIdsWithDietOptionCalories,
      serverUrl,
      apiKey,
      selectedDietOption.dietOptionId
    )
      .then(res => {
        const { data, status } = res;
        if (status === 200) {
          dispatch(mealExchangeSelectMenuMeal(id, mealId, data));
        }
      })
      .catch(e => {
        console.log(e, 'e');
      });
  };

export const toggleMeal =
  (companyName, activeDay, id, items, toggle, serverUrl, apiKey) =>
  (dispatch, getState) => {
    const selectedDietOption = getSelectedOption(getState());

    if (toggle === 'on') {
      const mealsIdsWithDietOptionCalories = `${items.dietOptionId}_${items.calories}_${items.mealId}`;
      getApiCompanyMenuMeals(
        companyName,
        activeDay,
        mealsIdsWithDietOptionCalories,
        serverUrl,
        apiKey,
        selectedDietOption.dietOptionId
      )
        .then(res => {
          const { data, status } = res;
          if (status === 200) {
            dispatch(mealExchangeToggleMeal(id, items.mealId, data, toggle));
          }
        })
        .catch(e => {
          console.log(e, 'e');
        });
    }

    if (toggle === 'off') {
      dispatch(mealExchangeToggleMeal(id, items.mealId, items.list, toggle));
    }
  };

export const validSideOrders =
  (mealsListPerDay, sideOrdersPerDay, changeType, sideOrder, min, max) =>
  dispatch => {
    const { limitedByMaximumSelectedMeals, minQuantity } = sideOrder;

    const lengthSelectedMealsWithSideOrders =
      getLengthSelectedMealsWithSideOrders(mealsListPerDay, sideOrdersPerDay);

    if (limitedByMaximumSelectedMeals) {
      if (changeType === 'increase' || changeType === 'add') {
        if (changeType === 'increase') {
          if (lengthSelectedMealsWithSideOrders >= max) {
            dispatch(changeMinMaxModalStatus('max'));
            return false;
          }
        }

        if (changeType === 'add') {
          if (lengthSelectedMealsWithSideOrders + minQuantity >= max) {
            dispatch(changeMinMaxModalStatus('max'));
            return false;
          }
        }

        return true;
      }

      if (lengthSelectedMealsWithSideOrders === min) {
        dispatch(changeMinMaxModalStatus('min'));
        return false;
      }
    }

    return true;
  };

export const validMeals =
  (mealsListPerDay, sideOrdersPerDay, min, max, validType) => dispatch => {
    const lengthSelectedMealsWithSideOrders =
      getLengthSelectedMealsWithSideOrders(mealsListPerDay, sideOrdersPerDay);

    if (validType === 'max') {
      if (lengthSelectedMealsWithSideOrders >= max) {
        dispatch(changeMinMaxModalStatus('max'));
        return false;
      }
    }
    if (validType === 'min') {
      if (lengthSelectedMealsWithSideOrders === min) {
        dispatch(changeMinMaxModalStatus('min'));
        return false;
      }
    }

    if (validType === 'minMeals') {
      const lengthSelectedMeals = getLengthSelectedMeals(mealsListPerDay);

      if (lengthSelectedMeals === min) {
        dispatch(changeMinMaxModalStatus('min'));
        return false;
      }
    }

    return true;
  };

export const getLengthOfMealsPerDayByMealName = (mealsListPerDay, mealName) =>
  mealsListPerDay.filter(item => item.mealName === mealName).length;

export const displayAddMealButton = (
  mealsListPerDay,
  items,
  addingMealsEnabled
) => {
  const filteredMealsListPerDay = mealsListPerDay.filter(
    item => item.mealName === items.mealName
  );

  return (
    filteredMealsListPerDay[filteredMealsListPerDay.length - 1].id ===
      items.id && addingMealsEnabled
  );
};

export const scrollToNextMeal = (refs, id) => {
  const indexOfClickedItem = Object.keys(refs).indexOf(id);
  Object.values(refs)[indexOfClickedItem + 1]?.current.scrollIntoView({
    behavior: 'smooth',
    block: 'center',
  });
};
